const Why = () => {

    const whyContents = [
        { title: 'Pembelajaran Fleksibel', text: 'Belajar Tanpa Batasan Waktu dan Tempat dan Didukung Teknologi.' },
        { title: 'Materi Belajar Terstruktur', text: 'Dengan Pendekatan Best Practice Menjadikan Belajar Bukan Sekadar Teori.' },
        { title: 'Mentor Expert Terpercaya', text: 'Belajar Langsung dari Mentor Praktisi Expert Terpercaya Dibidangnya.' },
        { title: 'Fasilitas Belajar Lengkap', text: 'Sertifikat, Rekaman, Materi, Grup Diskusi sampai Akses Loker Semuanya Dapat!' }
    ];

    return (
        <div id="whySection">
            <div className="py-5" style={{ background: '#00000008' }}>
                <h2 className="fw-bold text-center mb-4">
                    Kenapa Jadipraktisi?
                </h2>

                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="p-3">
                                <img src="/assets/img/testimonial/why-image.webp" className="img-fluid" alt="Why" />
                            </div>
                        </div>

                        <div className="col-md-6 d-flex align-items-center">
                            <div className="row">
                                {whyContents.map((item, index) => (
                                    <div className="col-md-6 mb-3">
                                        <div className="card card-why h-100 shadow-none" style={{ borderRadius: '20px' }}>
                                            <div className="card-body">
                                                <h5 className="fw-bold text-primary">
                                                    {item.title}
                                                </h5>
                                                <p className="fw-medium mt-3 mb-0" style={{ color: '#1E344C' }}>
                                                    {item.text}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Why;